import { render, staticRenderFns } from "./ArchitectureDemo.vue?vue&type=template&id=381636b8&scoped=true"
import script from "./ArchitectureDemo.vue?vue&type=script&lang=js"
export * from "./ArchitectureDemo.vue?vue&type=script&lang=js"
import style0 from "./ArchitectureDemo.vue?vue&type=style&index=0&id=381636b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381636b8",
  null
  
)

export default component.exports